import { parse, stringify } from 'hub-http/helpers/params';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Metrics } from 'LearningCenterUI/Metrics';
import { usePlaylist } from '../savedItems/savedItemsQueries';
export const useIncorrectPlaylistRedirect = ({
  id,
  type,
  playlistId
}) => {
  const {
    playlist,
    playlistLoading,
    playlistError
  } = usePlaylist(playlistId, !playlistId);
  const history = useHistory();
  useEffect(() => {
    const playlistMissing = playlistError || !playlistLoading && !playlist;
    const itemMissing = playlist && !playlist.items.find(item => item.type === type && item.itemId === id);
    if (playlistMissing || itemMissing) {
      const params = parse(history.location.search.slice(1));
      delete params.playlistId;
      const newSearch = stringify(params);
      history.push(Object.assign({}, history.location, {
        search: newSearch.length > 1 ? newSearch : ''
      }));
    }
    if (playlistMissing) {
      Metrics.counter('current-playlist-missing-redirect').increment();
    } else if (itemMissing) {
      switch (type) {
        case 'TRACK':
          Metrics.counter('current-track-not-in-playlist-redirect').increment();
          break;
        case 'LESSON':
          Metrics.counter('current-lesson-not-in-playlist-redirect').increment();
          break;
        case 'SHORT_FORM_CONTENT':
          Metrics.counter('current-short-not-in-playlist-redirect').increment();
          break;
        default:
          Metrics.counter('current-unkown-item-not-in-playlist-redirect').increment();
      }
    }
  }, [history, id, playlist, playlistError, playlistLoading, type]);
};
export const usePlaylistIdFromSearch = () => {
  const {
    search
  } = useLocation();
  const params = new URLSearchParams(search);
  const playlistIdSearchString = params.get('playlistId');
  if (playlistIdSearchString) return parseInt(playlistIdSearchString, 10);
  return null;
};